import AbstractModel from './AbstractModel';
import {IAppSetting} from '../../../@interfaces/services/Database';

export default class AppSetting extends AbstractModel<IAppSetting> implements IAppSetting {
	name!: string;
	value!: string | number | boolean;
	service?: string;

	protected get table() {
		return this.connection.settings;
	}

	static async get(service: string, name: string): Promise<string | number | boolean | null> {
		return (await AppSetting.model(service, name))?.value ?? null;
	}

	static async set(service: string, name: string, value: string): Promise<void> {
		AppSetting.query().put({service, name, value});
	}

	static async delete(service: string, name: string): Promise<void> {
		AppSetting.query().where({service, name}).delete();
	}

	protected static async model(service: string, name: string): Promise<AppSetting | undefined> {
		return AppSetting.query().where({service, name}).first();
	}
}
